import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

const MarkdownLinkRenderer = ({ href, children }) => {
	const isRelative = !href.startsWith('http') && !href.startsWith('//');

	if (isRelative) {
		return (
			<Link
				component={RouterLink}
				to={href}
				underline='none'
				variant='body1'
				color='secondary'
			>
				{children}
			</Link>
		);
	}

	const target = href.includes('ashlink.com') ? '_self' : '_blank';

	return (
		<Link
			href={href}
			target={target}
			rel='noreferrer'
			underline='none'
			variant='body1'
			color='secondary'
		>
			{children}
		</Link>
	);
};

MarkdownLinkRenderer.propTypes = {
	href: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
};

export default MarkdownLinkRenderer;
